import { api } from "../utils/api";
const CompanyService = {
  getCompany: async (companyId) => {
    try {
      const response = await api.get(`/api/companies/details/${companyId}`);
      return response.data;
    } catch (error) {
      return [];
    }
  },

  changePageStatus: async (companyId, page, status) => {
    // whether to enable or disable pages like career
    try {
      const response = await api.put(`/api/companies/external/page`, {
        page,
        companyId,
        status,
      });
      return response.data;
    } catch (erro) {
      return false;
    }
  },

  changeBullhornAccessLevel: async (level, companyId) => {
    try {
      const response = await api.put(`/api/companies/bullhorn/access/level`, {
        level,
        companyId,
      });
      return response.data;
    } catch (error) {
      return error.response.data;
    }
  },
};

export default CompanyService;
